export default [{
  id: "0",
  title: "RESERVED",
  startDate: "2020-03-31",
  classes: "morning",
}, {
  id: "1",
  title: "RESERVED",
  startDate: "2020-03-31",
  classes: "evening",
}, {
  id: "2",
  title: "RESERVED",
  startDate: "2020-04-01",
  classes: "morning",
}, {
  id: "3",
  title: "RESERVED",
  startDate: "2020-04-01",
  classes: "evening",
}, {
  id: "4",
  title: "RESERVED",
  startDate: "2020-04-10",
  classes: "evening",
}, {
  id: "5",
  title: "RESERVED",
  startDate: "2020-04-22",
  classes: "morning",
}, {
  id: "6",
  title: "RESERVED",
  startDate: "2020-04-22",
  classes: "evening",
}, {
  id: "7",
  title: "RESERVED",
  startDate: "2020-04-23",
  classes: "morning",
}, {
  id: "8",
  title: "RESERVED",
  startDate: "2020-05-22",
  classes: "morning",
}, {
  id: "9",
  title: "RESERVED",
  startDate: "2020-05-22",
  classes: "evening",
}, {
  id: "10",
  title: "RESERVED",
  startDate: "2020-05-25",
  classes: "morning",
}, ]